import { PreloadAllModules, RouterModule } from "@angular/router";
import { unsupportedAppVersionGuard } from "../authentication/unsupported-app-version.guard";
import { UnsupportedAppVersionContainer } from "../authentication/unsupported-app-version.container";
import { canActivateForAppInError } from "../something-went-wrong/something-went-wrong.guard";

export const routing = RouterModule.forRoot(
	[
		{
			path: "",
			redirectTo: "home",
			pathMatch: "full",
		},
		{
			path: "",
			loadChildren: () =>
				import("../something-went-wrong/something-went-wrong.module").then((m) => m.SomethingWentWrongModule),
		},
		{
			path: "auth/unsupported-app-version",
			component: UnsupportedAppVersionContainer,
			canActivate: [canActivateForAppInError],
		},
		{
			path: "",
			canActivate: [unsupportedAppVersionGuard],
			children: [
				{
					path: "",
					loadChildren: () => import("../authentication/auth.module").then((m) => m.AuthModule),
				},
				{
					path: "",
					loadChildren: () => import("../setup/setup.module").then((m) => m.SetupModule),
				},
				{
					path: "",
					loadChildren: () => import("../home/home.module").then((m) => m.HomeModule),
				},
				{
					path: "",
					loadChildren: () => import("../settings/settings.module").then((m) => m.SettingsModule),
				},
				{
					path: "",
					loadChildren: () => import("../call-event/call-event.module").then((m) => m.CallEventModule),
				},
				{
					path: "",
					loadChildren: () => import("../tasks/tasks.module").then((m) => m.TasksModule),
				},
				{
					path: "",
					loadChildren: () => import("../medical-data/medical-data.module").then((m) => m.MedicalDataModule),
				},
				{
					path: "",
					loadChildren: () => import("../wound-care/wound-care.module").then((m) => m.WoundCareModule),
				},
				{
					path: "",
					loadChildren: () => import("../patient/patient.module").then((m) => m.PatientModule),
				},
				{
					path: "**",
					redirectTo: "home",
				},
			],
		},
	],
	{
		bindToComponentInputs: true,
		paramsInheritanceStrategy: "always",
		preloadingStrategy: PreloadAllModules,
	},
);
